
export interface WsMessage {
	data: {
		old_status: string,
		new_status: string
	};
	domain: WsMessageType;
	eventType: string;
	identifier: {
		projectId: string,
		partId: string
	};
	partId: string;
	projectId: string;
	originator: string;
	subEventType?: string;
	userId?: string;
}

export enum WsMessageType {
	ITEM = 'ITEM',
	PART = 'PART',
	PROJECT = 'PROJECT',
	MAINTENANCE = 'MAINTENANCE',
	QUOTATION = 'QUOTATION'
}

/** Payload of a `QUOTATION` websocket push: a finished PDF render. `quotationId`/`jobId`
 * let the page match the push to the render it kicked off; `pdfUrl` is the presigned
 * download link. Mirrors quotationservice `notify_quotation_ready`. */
export interface QuotationReadyData {
	pdfUrl: string;
	orderName?: string;
	quotationId?: string;
	jobId?: string;
	pdfKey?: string;
}

export type EffectStatus = 'PENDING' | 'IN_PROGRESS' | 'COMPLETE' | 'FAILED' | 'NOT_IN_SCOPE';

/** Scope of a change or effect, mirroring the backend `Identifier`. Every field is
 * optional: which ones are set is what says whether something targets a project, a
 * part, a single item or a cutting list line. */
export interface Identifier {
	projectId?: string;
	partId?: string;
	itemId?: string;
	articleId?: string;
	cuttingListId?: string;
	cuttingListLineId?: string;
	accountId?: string;
	customisationId?: string;
}

export interface EffectStatusData {
	correlationId: string;
	effectId: string;
	effectType: string;
	status: EffectStatus;
	initiatedBy?: string;
	registeredBy: string;
	registeredAt: string;
	completedAt?: string;
	errorMessage?: string;
	label?: string;
	/** Entity the effect targets. Absent on project-wide effects; present when the
	 * effect is one of many under a change, which is what lets progress be attributed
	 * to a single part/item rather than the whole project. */
	identifier?: Identifier;
}

export interface ChangeStatusData {
	correlationId: string;
	description?: string;
	originator: string;
	createdAt: string;
	effects: EffectStatusData[];
}
